<script lang="ts">
  import Button from '$mds/Buttons/Button';
  import Image from '$mds/Image';
  import Pattern from '$assets/svgs/patterns/pattern_02.svg?component';

  let className = '';
  export { className as class };
  export let kind: 'small' | 'large' = 'small';
  export let title: string | undefined = undefined;
  export let subtitle: string | undefined = '';
  export let illustration = '';
  export let cta = '';
  export let href = '';
  export let isExternal = false;
  export let showBg = false;
  export let padding: string | undefined = undefined;
  export let imageSize = 'size-52 md:size-60';

  let smallClass = kind === 'small' ? 'bg-gradient-small rounded-lg' : '';
  let largeClass = kind === 'large' ? 'relative overflow-hidden' : '';
  let smallPadding = kind === 'small' ? (padding ? padding : 'px-4 py-12') : '';
  let largePadding = kind === 'large' ? (padding ? padding : 'px-5 py-20') : '';
</script>

<article
  class="flex w-full flex-col items-center text-center
    {smallClass} {largeClass} {smallPadding} {largePadding} {className}"
>
  {#if kind === 'small'}
    <h3 class="text-ondark-primary mb-2 font-semibold">{title}</h3>
    <p class="max-w-[19.5rem] text-balance text-sm">
      <slot>
        {subtitle}
      </slot>
    </p>
    <slot name="cta">
      {#if !!cta}
        <Button variant="primary" size="lg" class="mt-4" {href} on:click>{cta}</Button>
      {:else if !!href}
        <a
          class="text-action-ondark-base mt-4 inline-flex text-center font-medium hover:underline"
          {href}
          {...{ ...(isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : {}) }}
        >
          {cta}
        </a>
      {/if}
    </slot>
  {:else}
    {#if showBg}
      <Pattern
        class="text-onlight-secondary absolute left-1/2 top-1/2 z-0 h-auto min-w-full -translate-x-1/2 -translate-y-1/2 rotate-180"
      />
      <div class="to-nd-10 absolute inset-0 z-0 bg-gradient-to-b from-transparent" />
    {/if}

    <div class="z-1 flex flex-col items-center">
      <Image class="mb-6 {imageSize} md:mb-8" src={illustration} alt="No Results Found" />
      <slot name="content">
        <h1 class="text-display-sm text-ondark-primary mb-4 md:mb-5">{title}</h1>
        <p class="text-body-base max-w-[25.75rem]">{subtitle}</p>
      </slot>
      {#if cta !== ''}
        <Button variant="primary" size="lg" class="mt-8" {href} on:click>{cta}</Button>
      {/if}
    </div>
  {/if}
</article>

<style>
  .bg-gradient-small {
    background: linear-gradient(180deg, theme('colors.nd.9') 0%, theme('colors.nd.9 / 0%') 75.18%);
  }
</style>
